import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export const returnDraftToEditing = api(async function returnDraftToEditing({ projectId, scheduleId, reason }) {
    if (!projectId || !scheduleId) return false

    return mutate(
        gql`
            mutation ReturnDraftToEditing($projectId: String!, $scheduleId: String!, $reason: String) {
                returnDraftToEditing(projectId: $projectId, scheduleId: $scheduleId, reason: $reason)
            }
        `,
        { projectId, scheduleId, reason },
        { returns: "returnDraftToEditing" }
    )
})
